// Article #8 — Pool Resurfacing Process: What to Expect Before, During, and
// After. The visible FAQ section and the FAQPage schema both read from this
// single array, so they always match exactly.
export const FAQS_POOL_RESURFACING_PROCESS: {
  question: string;
  answer: string;
}[] = [
  {
    question: "What are the main steps in pool resurfacing?",
    answer:
      "The typical sequence includes planning and finish selection, professional draining, inspection and surface preparation, approved repairs, new-finish application, initial filling, startup, and early water care. The exact preparation and startup procedures depend on the existing pool, selected finish, written scope, and manufacturer instructions.",
  },
  {
    question: "Does all of the old pool finish have to be removed?",
    answer:
      "Not necessarily. The required preparation depends on the condition and type of the existing surface, the selected finish system, bonding requirements, and written project specification. Unsound material must be addressed, but it is inaccurate to claim every pool requires an identical complete chip-out.",
  },
  {
    question: "Can I drain the pool myself before the contractor arrives?",
    answer:
      "Do not drain the pool unless the project team specifically directs and coordinates it. Empty-pool conditions can involve groundwater, hydrostatic pressure, weather, drainage, equipment, and property-protection concerns that require professional management.",
  },
  {
    question:
      "Can the water be turned off while the resurfaced pool is filling?",
    answer:
      "Many cementitious finish systems instruct users to fill continuously without interruption because stopping can leave a visible line or affect the surface. Follow the written instructions for the exact installed product and contact the responsible professional immediately if the fill stops unexpectedly.",
  },
  {
    question: "How long does pool resurfacing take?",
    answer:
      "Active construction may take several working days for a straightforward project, but preparation, repairs, related renovations, weather, inspections, filling, and other conditions can extend the schedule. Startup and early care continue after finish application, so ask which milestone a quoted duration actually describes.",
  },
  {
    question: "When can I swim after pool resurfacing?",
    answer:
      "Swim only after the pool is completely filled and the responsible professional confirms that circulation, sanitation, water balance, surface conditions, and applicable manufacturer requirements allow use. There is no single waiting period appropriate for every finish and startup method.",
  },
  {
    question: "Who handles brushing and water chemistry after resurfacing?",
    answer:
      "Responsibility varies by contract. The installer, a startup provider, the regular pool-service company, or the homeowner may handle different tasks. The proposal should identify who performs testing, balancing, brushing, equipment startup, documentation, and follow-up care.",
  },
  {
    question:
      "When can I turn on the heater, automatic cleaner, or salt system?",
    answer:
      "These items may have separate manufacturer-specific restrictions after a new finish is installed. Do not activate them based on the pool's previous routine. Obtain written direction for the exact finish, startup method, and equipment.",
  },
];

export const TOC_POOL_RESURFACING_PROCESS = [
  { id: "the-short-answer", title: "The Short Answer" },
  {
    id: "before-pool-resurfacing-begins",
    title: "Before Pool Resurfacing Begins",
  },
  { id: "step-1-draining-the-pool", title: "Step 1: Draining the Pool" },
  {
    id: "step-2-inspecting-and-preparing-the-surface",
    title: "Step 2: Inspecting and Preparing the Existing Surface",
  },
  {
    id: "step-3-approved-repairs-and-related-work",
    title: "Step 3: Completing Approved Repairs and Related Work",
  },
  {
    id: "step-4-applying-the-new-pool-finish",
    title: "Step 4: Applying the New Pool Finish",
  },
  { id: "step-5-refilling-the-pool", title: "Step 5: Refilling the Pool" },
  {
    id: "step-6-startup-brushing-and-water-care",
    title: "Step 6: Startup, Brushing, and Early Water Care",
  },
  {
    id: "when-can-you-use-the-pool-again",
    title: "When Can You Use the Pool Again?",
  },
  {
    id: "how-long-does-pool-resurfacing-take",
    title: "How Long Does Pool Resurfacing Take?",
  },
  { id: "what-can-delay-the-process", title: "What Can Delay the Process?" },
  {
    id: "homeowner-resurfacing-checklist",
    title: "Homeowner Checklist Before, During, and After Resurfacing",
  },
  {
    id: "south-florida-conditions",
    title: "South Florida Conditions That Affect the Process",
  },
  { id: "frequently-asked-questions", title: "Frequently Asked Questions" },
];
